import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as _ from 'lodash';
import { catchError, map, switchMap } from 'rxjs/operators';

import { FinancialDataManagerCreateActions } from '../actions';
import { OnboardingProductsService } from '../../services/onboarding-products.service';
import { Common } from './common';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { OnboardingProductsStore } from '../store';

@Injectable()
export class FinancialDataManagerCreateEffects {
  constructor(
    private actions$: Actions,
    private onboardingProductsService: OnboardingProductsService,
    private store: Store<OnboardingProductsStore.AppState>
  ) {}

  private common = new Common();

  getFinancialDataManagerCreate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FinancialDataManagerCreateActions.getFinancialDataManagerCreate),
      switchMap((action) =>
        this.onboardingProductsService.getFinancialDataManagerCreate(action.request).pipe(
          map((res) => this.common.responseInterpreter(res)),
          map((res) => res['middleware']),
          map((res) =>
            FinancialDataManagerCreateActions.getFinancialDataManagerCreateSucess({ response: res })
          ),
          catchError((error) =>
            of(
              FinancialDataManagerCreateActions.getFinancialDataManagerCreateError({
                payload: this.common.handleErrorsDefault(error)
              })
            )
          )
        )
      )
    )
  );
}
